import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { salesQuoteService } from '../../../services/salesQuoteService';
import VentasCommercialForm from '../../../components/Ventas/VentasCommercialForm';
import Toast from '../../../components/Common/Toast';
import SalesQuotePdfButton from '../../../components/Ventas/SalesQuotePdfButton';
import SalesQuotePrintButton from '../../../components/Ventas/SalesQuotePrintButton';
import SalesQuoteProgressBar from '../../../components/Ventas/SalesQuoteProgressBar';
import { getSalesQuoteFulfillmentLabel } from '../../../utils/salesQuoteProgress';

const EditVentasQuote = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const load = async () => {
      try {
        const res = await salesQuoteService.getQuote(id);
        if (res.success) setQuote(res.data);
        else navigate('/ventas/quotes', { state: { posConfirmed: true } });
      } catch {
        navigate('/ventas/quotes', { state: { posConfirmed: true } });
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id, navigate]);

  if (loading) {
    return <div className="p-6 text-center text-gray-500">Cargando...</div>;
  }

  const readOnly = quote?.status === 'cancelled';

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">
              {readOnly ? 'Ver cotización' : 'Editar cotización'}
            </h1>
            <p className="text-sm font-mono text-teal-600 mt-1">{quote?.code}</p>
            {quote && (
              <div className="mt-3 flex flex-wrap items-center gap-3">
                <SalesQuoteProgressBar quote={quote} className="w-48" barClassName="h-2.5" />
                {(() => {
                  const status = getSalesQuoteFulfillmentLabel(quote);
                  return (
                    <span className={`px-2 py-1 text-xs rounded-full ${status.className}`}>
                      {status.label}
                    </span>
                  );
                })()}
              </div>
            )}
          </div>
          {quote?.id && (
            <div className="flex items-center gap-3">
              <SalesQuotePrintButton quoteId={quote.id} />
              <SalesQuotePdfButton
                quoteId={quote.id}
                showLabel
                onSuccess={() =>
                  setToast({ isOpen: true, message: `PDF de ${quote.code} descargado`, type: 'success' })
                }
                onError={(message) =>
                  setToast({ isOpen: true, message: message || 'Error al generar el PDF', type: 'error' })
                }
              />
            </div>
          )}
        </div>
        <VentasCommercialForm
          mode="quote"
          entity={quote}
          readOnly={readOnly}
          isPageMode
          onClose={() => navigate('/ventas/quotes', { state: { posConfirmed: true } })}
          onSuccess={() => navigate('/ventas/quotes', { state: { posConfirmed: true } })}
        />
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default EditVentasQuote;
